export function useScrollVideo(videoRef: Ref<HTMLVideoElement | null | undefined>) {
    const { $ScrollTrigger: ScrollTrigger } = useNuxtApp();
    let videoTrigger: { kill: () => void; isActive?: boolean } | null = null;

    const playVideo = () => {
        const video = videoRef.value;
        if (!video) {
            return;
        }

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => undefined);
        }
    };

    const pauseVideo = () => {
        videoRef.value?.pause();
    };

    onMounted(() => {
        if (!ScrollTrigger || !videoRef.value) {
            return;
        }

        videoTrigger = ScrollTrigger.create({
            trigger: videoRef.value,
            start: 'top bottom',
            end: 'bottom top',
            onEnter: playVideo,
            onEnterBack: playVideo,
            onLeave: pauseVideo,
            onLeaveBack: pauseVideo
        });

        if (videoTrigger.isActive) {
            playVideo();
        } else {
            pauseVideo();
        }
    });

    onBeforeUnmount(() => {
        videoTrigger?.kill();
    });

    return { playVideo, pauseVideo };
}
